class VarietyPackMini extends HTMLElement {
    constructor() {
        super();
        this.quantity = 1;
        this.variantId = this.querySelector(".variety-pack-mini-add-to-cart").getAttribute("data-variant-id");

        this.querySelector(".variety-pack-mini-quantity-input-plus").addEventListener("click", this.plusQuantity.bind(this));
        this.querySelector(".variety-pack-mini-quantity-input-minus").addEventListener("click", this.minusQuantity.bind(this));
        this.querySelector(".variety-pack-mini-add-to-cart").addEventListener("click", this.addToCart.bind(this));
    }

    plusQuantity() {
        this.quantity += 1;
        this.querySelector(".variety-pack-mini-quantity input").value = this.quantity;
    }

    minusQuantity() {
        if (this.quantity === 1) return;
        this.quantity -= 1;
        this.querySelector(".variety-pack-mini-quantity input").value = this.quantity;
    }

    async addToCart() {
        this.querySelector(".variety-pack-mini-add-to-cart").classList.add("loading");
        this.querySelector(".variety-pack-mini-add-to-cart .loading__spinner").classList.remove("hidden");

        const cartObject = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

        let formData = new FormData();

        formData.append('items[][id]', this.variantId);
        formData.append('items[][quantity]', this.quantity);

        if (cartObject) {
            formData.append(
                'sections',
                cartObject.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
        }

        await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        }).then(response => response.json())
            .then(data => {
                this.querySelector(".variety-pack-mini-add-to-cart").classList.remove("loading");
                this.querySelector(".variety-pack-mini-add-to-cart .loading__spinner").classList.add("hidden");
                if (!cartObject) return
                cartObject.classList.remove('is-empty')
                cartObject.renderContents(data)
            })

    }
}

customElements.define("variety-pack-mini", VarietyPackMini);